export default __webpack_public_path__ + "static/jni-e1aa3011ca28dc831e040fd1c3279cb6.png";